/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timing_Sync_Modifier_HintInputs */

const en_timing_sync_modifier_hint = /** @type {(inputs: Timing_Sync_Modifier_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We suggest adding a key modifier (such as Ctrl, Shift, or Command) when configuring your keyboard shortcuts.`)
};

const fr_timing_sync_modifier_hint = /** @type {(inputs: Timing_Sync_Modifier_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nous recommandons d'ajouter un modificateur de touche (Ctrl, Shift ou Command) lors de la configuration des raccourcis clavier.`)
};

const de_timing_sync_modifier_hint = /** @type {(inputs: Timing_Sync_Modifier_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wir empfehlen, beim Konfigurieren Ihrer Tastenkombinationen eine Tastenmodifikationstaste (z. B. Strg, Umschalt oder Befehl) hinzuzufügen.`)
};

const it_timing_sync_modifier_hint = /** @type {(inputs: Timing_Sync_Modifier_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ti consigliamo di aggiungere un tasto modificatore (ad esempio Ctrl, Maiusc o Comando) quando configuri le scorciatoie da tastiera.`)
};

const ru_timing_sync_modifier_hint = /** @type {(inputs: Timing_Sync_Modifier_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Мы рекомендуем добавить клавишу-модификатор (например, Ctrl, Shift или Command) при настройке сочетаний клавиш.`)
};

const es_timing_sync_modifier_hint = /** @type {(inputs: Timing_Sync_Modifier_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le sugerimos agregar un modificador de tecla (como Ctrl, Shift o Comando) al configurar sus atajos de teclado.`)
};

const zh_cn2_timing_sync_modifier_hint = /** @type {(inputs: Timing_Sync_Modifier_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我们建议在配置键盘快捷键时添加键修饰键（例如 Ctrl、Shift 或 Command）。`)
};

const ja_timing_sync_modifier_hint = /** @type {(inputs: Timing_Sync_Modifier_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キーボード ショートカットを設定するときは、キー修飾子 (Ctrl、Shift、Command など) を追加することをお勧めします。`)
};

const hi_timing_sync_modifier_hint = /** @type {(inputs: Timing_Sync_Modifier_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हम सुझाव देते हैं कि कीबोर्ड शॉर्टकट कॉन्फ़िगर करते समय एक कुंजी संशोधक (जैसे Ctrl, Shift, या Command) जोड़ें।`)
};

const pt_pt2_timing_sync_modifier_hint = /** @type {(inputs: Timing_Sync_Modifier_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sugerimos adicionar uma tecla modificadora (como Ctrl, Shift ou Command) ao configurar seus atalhos de teclado.`)
};

/**
* | output |
* | --- |
* | "We suggest adding a key modifier (such as Ctrl, Shift, or Command) when configuring your keyboard shortcuts." |
*
* @param {Timing_Sync_Modifier_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timing_sync_modifier_hint = /** @type {((inputs?: Timing_Sync_Modifier_HintInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timing_Sync_Modifier_HintInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_timing_sync_modifier_hint(inputs)
	if (locale === "de") return de_timing_sync_modifier_hint(inputs)
	if (locale === "it") return it_timing_sync_modifier_hint(inputs)
	if (locale === "ru") return ru_timing_sync_modifier_hint(inputs)
	if (locale === "es") return es_timing_sync_modifier_hint(inputs)
	if (locale === "zh-CN") return zh_cn2_timing_sync_modifier_hint(inputs)
	if (locale === "ja") return ja_timing_sync_modifier_hint(inputs)
	if (locale === "hi") return hi_timing_sync_modifier_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_timing_sync_modifier_hint(inputs)
	return en_timing_sync_modifier_hint(inputs)
});